<template>
  <div
    :class="{
      'benefit-info': true,
      'benefit-info-margin': true,
    }"
  >
    <div class="benefit-info-title">
      {{ benefitInfo.title }}
    </div>
    <div class="benefit-info-inner">
      <div class="benefit-name">
        <div class="benefit-icon">
          <van-image lazy-load :src="benefitIcon" />
        </div>
        <div class="benefit-header-info">
          <div class="benefit-title">
            <span class="benefit-title-span">{{ getSecondTitle }}</span>
          </div>
          <div class="benefit-subtitle">
            {{ benefitInfo.subtitle }}
          </div>
        </div>
        <span v-if="amount > 0" class="benefit-amount">剩{{ amount }}次</span>
      </div>
      <div class="benefit-sku">
        <benefit-sku
          :skuInfo="skuInfo"
          :selectSku="selectSku"
          :phone_account.sync="phone_account"
          :showAccount="showAccount"
          :updateSelectSku="updateSelectSku"
        />
        <benefit-btn-wrap
          :benefitInfo="benefitInfo"
          :selectSku="selectSku"
          :showAccount="showAccount"
          :account="account"
          :phone_account="phone_account"
          :benefit_type="benefit_type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BenefitBtnWrap from "./benefitBtnWrap";
import BenefitSku from "./benefitSku";
export default {
  components: { BenefitSku, BenefitBtnWrap },
  props: {
    benefit_type: String,
    benefitHeaderImage: String,
    benefitInfo: Object,
    skuInfo: Array,
    images: Object,
    selectSku: Object,
    updateSelectSku: Function,
  },
  data() {
    return {
      phone_account: "",
    };
  },
  computed: {
    ...mapState(["userInfo", "namespace", "namespaceInfo"]),
    account: {
      get() {
        return this.phone_account.replace(/ /g, "");
      },
      set() {},
    },
    showAccount() {
      return this.selectSku.allowed_recharge_account_types?.length > 0;
    },
    // 权益icon
    benefitIcon() {
      return this.images.titleIcon?.[0].image_url;
    },

    amount() {
      return (
        this.benefitInfo.amount_available + this.benefitInfo.amount_reserved
      );
    },

    getSecondTitle() {
      if (this.benefitInfo.brief_subtitle) {
        return this.benefitInfo.brief_subtitle;
      }
      return `本权益可用${
        this.benefitInfo.amount_available + this.benefitInfo.amount_reserved
      }次`;
      // if (
      //   this.benefitInfo.amount_available <= 0 &&
      //   this.benefitInfo.amount_reserved <= 0
      // ) {
      //   return "本权益已用完";
      // }
      // const unit = this.benefitInfo.use_period_frequency
      //   ? `本${this.benefitInfo.use_period_frequency}`
      //   : "当前";
      // return [
      //   `${unit}可用${this.benefitInfo.amount_available}次`,
      //   this.benefitInfo.next_use_wait_days !== null &&
      //     `距下${this.benefitInfo.use_period_frequency || "次"}使用还有${
      //       this.benefitInfo.next_use_wait_days
      //     }天`,
      // ]
      //   .filter(Boolean)
      //   .join("，");
    },
  },
};
</script>